import { render, staticRenderFns } from "./ColumnBasicMulti.vue?vue&type=template&id=afdd94ac&scoped=true&"
import script from "./ColumnBasicMulti.vue?vue&type=script&lang=js&"
export * from "./ColumnBasicMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afdd94ac",
  null
  
)

export default component.exports